// extracted by mini-css-extract-plugin
export default {"componentGrouping":"styles__componentGrouping___ciJF8","componentGroupingMany":"styles__componentGroupingMany___LM4YE styles__componentGrouping___ciJF8"};